export default "__VITE_ASSET__D08DhjHC__"